import React, { Component } from 'react'
import fetch from 'unfetch' // XXX: not using `lib/fetch` here, as it expects a CSRF token
import Loadable from 'react-loadable'
import { Spinner, majorScale } from '@segment/react-ui-library'
import { track as trackError } from 'lib/utils/errors'
import { trackTimeTillInteractive } from 'lib/utils/stats'
import EmptyPage from 'ui/EmptyPage'
import { Body1 } from 'ui/typography'
import ms from 'ms'

const Loader = () => <Spinner marginY={majorScale(8)} marginX="auto" />

const ErrorBody = (
  <Body1>There was an error initializing the Segment App.</Body1>
)

const ErrorPage = () => (
  <EmptyPage
    title="Initialization Error"
    buttonHref="https://segment.com/contact/support"
    buttonText="Contact Support"
    rel="external"
    body={ErrorBody}
  />
)

// we lazy-load the routes, since they're expecting a CSRF token to be set/usable immediately
const Routes = Loadable({
  loader: () => import(/* webpackChunkName: "routes" */ '../routes'),
  loading: () => <Loader />
})

const getCSRF = () =>
  fetch('/api/session/token', { credentials: 'include' }).then(res => {
    if (!res.ok) {
      throw new Error(`Unable to get token: ${res.status}`)
    }

    return res.text()
  })

// Root handles initializing the app. It grabs our CSRF token, then renders the router/etc.
class Root extends Component {
  static displayName = 'Root'

  state = {
    isLoading: true,
    isErrored: false
  }

  render() {
    if (this.state.isLoading) {
      return React.createElement(Loader)
    }

    if (this.state.isErrored) {
      return React.createElement(ErrorPage)
    }

    return React.createElement(Routes)
  }

  setupCSRF = async () => {
    try {
      global.CSRF = await getCSRF()
    } catch (err) {
      trackError(err)
      this.setState({ isErrored: true })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  async componentDidMount() {
    await this.setupCSRF()
    setInterval(this.setupCSRF, ms('1h'))
    trackTimeTillInteractive('spa')
  }
}

export default Root



// WEBPACK FOOTER //
// ./containers/Root.js